// test1659
(1659 && 0);
